import { render } from "./previewPdf.vue?vue&type=template&id=554085ef&scoped=true"
import script from "./previewPdf.vue?vue&type=script&lang=js"
export * from "./previewPdf.vue?vue&type=script&lang=js"

import "./previewPdf.vue?vue&type=style&index=0&id=554085ef&scoped=true&lang=scss"

import exportComponent from "D:\\新建文件夹\\workPage\\OA H5\\stgd.oa.mobile.h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-554085ef"]])

export default __exports__